import { RowExecutionState, RowExecutionStatus } from './MyAccessRequests.types';

export function getExecutionStateLabel(executionState?: RowExecutionState): string {
  if (!executionState || executionState.status === 'idle') {
    return '';
  }

  const labelMap: Record<RowExecutionStatus, string> = {
    idle: '',
    success: 'Success',
    failed: 'Failed'
  };

  return executionState.message
    ? `${labelMap[executionState.status]}: ${executionState.message}`
    : labelMap[executionState.status];
}

export function getExecutionStateColor(status?: RowExecutionStatus): string {
  switch (status) {
    case 'success':
      return '#107C10';
    case 'failed':
      return '#A4262C';
    default:
      return '#323130';
  }
}
